import { Button, Card, EmptyState } from "@helmr/ui";
import { Link } from "react-router-dom";
import { strings } from "./strings";

export function NotFound() {
  return (
    <Card>
      <EmptyState icon="search" title={strings.states.notFoundTitle} description={strings.states.notFoundBody} action={<Button as={Link} to="/home">{strings.states.backHome}</Button>} />
    </Card>
  );
}
